export const getInviteUserData = (id: string = '') => {
  const shareUrl = `${window.location.origin}?invite=${id}#register`;

  return {
    url: shareUrl,
    message: `Join me at: ${shareUrl}`,
  };
};
